import { Ticket } from 'lucide-react';
import { useSite } from '../context/SiteContext';
import HelpBar from './HelpBar';

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

const PageBanner = ({ showHelpButton = true }) => {
  const { settings, getImageUrl } = useSite();

  const hoy = new Date();
  const fechaHoy = `${hoy.getDate()} de ${MESES[hoy.getMonth()]}`;
  const conFecha = (t) => (t || '').replace(/{fecha}/gi, fechaHoy);

  const getBannerHeightClass = () => {
    const height = settings.banner_height || 'auto';
    if (height === 'small') return 'py-1.5 sm:py-3';
    if (height === 'medium') return 'py-2 sm:py-6';
    if (height === 'large') return 'py-3 sm:py-10';
    return 'py-2 sm:py-6';
  };

  const bannerStyle = {
    background: `linear-gradient(to bottom right, ${settings.banner_gradient_from || '#fbbf24'}, ${settings.banner_gradient_to || '#f59e0b'})`,
  };

  return (
    <div
      className={`-mx-4 -mt-6 rounded-none mb-2 sm:mx-0 sm:mt-0 sm:rounded-3xl sm:mb-4 px-4 sm:px-6 ${getBannerHeightClass()} text-slate-900`}
      style={bannerStyle}
      data-testid="page-banner"
    >
      <div className="flex sm:block items-center gap-2.5">
        <div className="flex items-center gap-2 sm:gap-4 flex-1 min-w-0 sm:mb-0">
          {(() => {
            const imgSize =
              settings.banner_image_size === 'large'
                ? 'w-16 h-16 sm:w-28 sm:h-28'
                : settings.banner_image_size === 'medium'
                ? 'w-14 h-14 sm:w-20 sm:h-20'
                : 'w-12 h-12 sm:w-14 sm:h-14';
            return settings.banner_image_url ? (
              <img
                src={getImageUrl(settings.banner_image_url)}
                alt=""
                width={112}
                height={112}
                fetchPriority="high"
                decoding="async"
                className={`${imgSize} rounded-lg sm:rounded-xl object-cover flex-shrink-0 bg-white`}
                data-testid="banner-image"
              />
            ) : (
              <div className={`${imgSize} bg-white/30 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0`}>
                <Ticket className="w-5 h-5 sm:w-7 sm:h-7 text-slate-900" />
              </div>
            );
          })()}
          <div className="min-w-0 flex-1 border-l-2 border-black/40 pl-2 sm:pl-4">
            <h1
              className="font-fredoka text-[11px] leading-[1.15] sm:text-2xl sm:leading-tight font-black uppercase tracking-tight line-clamp-3"
              style={{ color: settings.banner_title_color || '#000000' }}
            >
              {conFecha(settings.banner_title) || 'Cupones de Descuento'}
            </h1>
            {settings.banner_subtitle_enabled !== false && (
              <p
                className={`text-[10px] sm:text-sm font-bold leading-tight mt-1 ${
                  !settings.banner_show_description_mobile ? 'hidden sm:block' : ''
                }`}
                style={{ color: settings.banner_subtitle_color || '#000000' }}
              >
                {conFecha(settings.banner_subtitle) || 'Ahorra en tus compras con cupones verificados'}
              </p>
            )}
          </div>
        </div>

        {showHelpButton && (
          <div className="flex flex-row items-center gap-1.5 sm:gap-2 flex-shrink-0 sm:mt-3">
            <HelpBar />
          </div>
        )}
      </div>
    </div>
  );
};

export default PageBanner;
